import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const CarletonUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Carleton University"
      universityShortName="Carleton"
      slug="carleton-university"
      seoTitle="Carleton University Study Rooms | Ottawa Campus Study Guide"
      seoDescription="Complete guide to study rooms at Carleton University. Find MacOdrum Library, silent floors, and bookable rooms. Plus free 24/7 online alternative."
      seoKeywords="carleton university study rooms, carleton library, macodrum library, ottawa university study spaces, carleton silent study"
      canonicalUrl="/study-room/carleton-university/"
      heroDescription="A comprehensive guide to study rooms at Carleton in Ottawa, including MacOdrum Library's floor-based noise zones."
      libraryWebsiteUrl="https://library.carleton.ca/"
      libraryWebsiteName="Carleton Library"
      studySpaces={[
        {
          name: "MacOdrum Library - Study Rooms",
          features: "Rooms with tables, chairs, and whiteboards (not soundproof). Bookable up to one week in advance for three hours per day. Available until 10 pm.",
          feedback: "High demand; bring your own markers."
        },
        {
          name: "Silent Floors (3 & 5)",
          features: "Designated silent study floors for complete focus.",
          feedback: "Valued for concentration; fills during exams."
        },
        {
          name: "Conversational Floors (2 & 4)",
          features: "Floors allowing normal conversation for group work.",
          feedback: "Good for collaborative projects."
        },
        {
          name: "VR-Compatible Rooms (467 & 469)",
          features: "Rooms equipped for virtual reality tools and projects.",
          feedback: "Unique resource for VR-based coursework."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Decide whether your group needs to talk; book a room on a <strong>conversational floor</strong> if yes. Bring whiteboard markers, arrive promptly to check in and choose <strong>VR-compatible rooms (467 or 469)</strong> if you plan to use virtual-reality tools.
          </p>
          <p className="mb-4">
            Users must <strong>check in with a QR code</strong>; failure to check in within 15 minutes results in cancellation. The check-in system can be inconvenient if your device doesn't share location.
          </p>
          <p>
            Students like the ability to choose between silent and conversational floors, but note that group rooms are in high demand.
          </p>
        </>
      }
      summaryTips={[
        "Choose your floor: Floors 3 & 5 for silence, 2 & 4 for conversation.",
        "Check in via QR code: Must check in within 15 minutes or lose booking.",
        "Bring whiteboard markers: Essential for using room whiteboards.",
        "Try VR rooms 467 & 469: Unique equipment for virtual reality projects.",
        "Use CSW for no check-in hassle: Instant access without QR codes."
      ]}
    />
  );
};

export default CarletonUniversity;
